import {Component, Inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-add-contract-quote-structure',
  templateUrl: './contract-quote-structure-add.component.html',
  styleUrls: ['./contract-quote-structure-add.component.scss']
})
export class ContractQuoteStructureAddComponent {

  constructor(public dialogRef: MatDialogRef<ContractQuoteStructureAddComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  step = 1;

  ok() {
    this.dialogRef.close({isOk: true});
  }

  cancel() {
    this.dialogRef.close({isCancel: true});
  }

  selectStep(value) {
    this.step = value;
  }
}
